import { z } from 'zod';
import { authoritativeTeamStateSchema, scenarioSchema } from './domain/game.js';
export const informationSchema = z.object({
    informationId: z.string().min(1),
    label: z.string().min(1).max(200),
    content: z.string().min(1).max(10_000),
    visibility: z.enum(['PUBLIC', 'TEAM']),
    teamId: z.string().optional(),
});
export const teamViewSchema = z.object({
    gameId: z.string(),
    phase: z.string(),
    roundNo: z.number().int().positive().nullable(),
    scenario: scenarioSchema,
    team: z.object({
        teamId: z.string(),
        displayName: z.string(),
        version: z.number().int().nonnegative(),
    }),
    organization: z.object({ name: z.string(), confirmed: z.boolean() }).nullable(),
    assignmentStatus: z.enum(['NOT_STARTED', 'PREPARED', 'REVEALED']),
    publicWorld: z.record(z.string(), z.unknown()),
    authoritativeState: authoritativeTeamStateSchema,
    information: z.array(informationSchema),
});
//# sourceMappingURL=game-view.js.map